<template>
  <div class="table-container pull-auto" style="width:99%;">
    <el-row>
      <el-col :span="5">
        <el-card class="box-card" >
          <div slot="header" class="clearfix" >
            <span>菜单名称</span>
          </div>
          <el-tree class="filter-tree" node-key="id" highlight-current :data="treeData"
          :default-expanded-keys="aExpandedKeys" :filter-node-method="filterNode"
          :props="defaultProps" @node-click="getNodeData" @node-expand="nodeExpand" @node-collapse="nodeCollapse">
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="18" :offset="1">
        <el-card class="box-card" >
          <div slot="header" class="clearfix" >
            <el-row>
              <el-button type="primary" v-if="menuManager_btn_add" size="mini" icon="el-icon-plus" @click="handlerRootAdd">添加顶级菜单</el-button>
              <el-button type="primary" v-if="menuManager_btn_add" size="mini" icon="el-icon-plus" @click="handlerAdd">添加下级菜单</el-button>
              <el-button type="primary" v-if="menuManager_btn_edit" size="mini" icon="el-icon-edit" @click="handlerEdit">编辑</el-button>
              <el-button type="primary" v-if="menuManager_btn_del" size="mini" icon="el-icon-delete" @click="handleDelete">删除</el-button>
            </el-row>
          </div>
          <el-form :label-position="labelPosition" label-width="80px" :model="form" ref="form">
            <el-form-item label="上级标题" prop="parentName">
              <el-input :model="form.parentId==-1?'根节点':form.parentName" :disabled="true"  placeholder="请输入上级标题"></el-input>
            </el-form-item>
            <el-form-item label="标题" prop="name">
              <el-input v-model="form.name" :disabled="formEdit"  placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="权限标识" prop="permission">
              <el-input v-model="form.permission" :disabled="formEdit" placeholder="请输入权限标识"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
              <el-input v-model="form.icon" :disabled="formEdit" placeholder="请输入图标"></el-input>
            </el-form-item>
            <el-form-item label="资源路径" prop="url">
              <el-input v-model="form.url" :disabled="formEdit" placeholder="请输入资源路径"></el-input>
            </el-form-item>
            <el-form-item label="请求方法" prop="method">
              <el-select class="filter-item" v-model="form.method"  :disabled="formEdit"  placeholder="请输入资源请求方法">
                <el-option v-for="item in  methodOptions" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select class="filter-item" v-model="form.type"  :disabled="formEdit"  placeholder="请输入资源请求类型">
                <el-option v-for="item in  typeOptions" :key="item" :label="item | typeFilter" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input v-model="form.sort" :disabled="formEdit" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="前端组件"   prop="component">
              <el-input v-model="form.component" :disabled="formEdit" placeholder="请输入描述"></el-input>
            </el-form-item>
            <el-form-item label="前端地址"   prop="component">
              <el-input v-model="form.path" :disabled="formEdit" placeholder="iframe嵌套地址"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" size="mini" v-if="formStatus == 'update'" icon="el-icon-success" @click="update">更新</el-button>
              <el-button type="primary" size="mini" v-if="formStatus == 'create'" icon="el-icon-success" @click="create">保存</el-button>
              <el-button @click="onCancel" size="mini" v-if="formStatus == 'create'||formStatus == 'update'" icon="el-icon-close">取消</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { fetchTree, getObj, addObj, delObj, putObj } from '@/api/admin/menu'
  import { mapGetters } from 'vuex'
  import { objKeySort } from '@/util/ajaxsign'
  export default {
    name: 'menu',
    data() {
      return {
        permissions : [],
        list: [],
        total: 0,
        formEdit: true,
        formAdd: true,
        formStatus: '',
        showElement: false,
        typeOptions: ['0', '1'],
        methodOptions: ['GET', 'POST', 'PUT', 'DELETE'],
        listQuery: {
          name: objKeySort({})
        },
        treeData: [],
        oExpandedKey: {
          // key (from tree id) : expandedOrNot boolean
        },
        oTreeNodeChildren: {
          // id1 : [children] (from tree node id1)
          // id2 : [children] (from tree node id2)
        },
        aExpandedKeys: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        labelPosition: 'right',
        form: {
          permission: undefined,
          name: undefined,
          menuId: undefined,
          parentId: undefined,
          parentName: undefined,
          url: undefined,
          icon: undefined,
          sort: undefined,
          component: undefined,
          type: undefined,
          method: undefined,
          path: undefined
        },
        currentId: -1,
        currentName: '根节点',
        menuManager_btn_add: false,
        menuManager_btn_edit: false,
        menuManager_btn_del: false
      }
    },
    filters: {
      typeFilter(type) {
        const typeMap = {
          0: '菜单',
          1: '按钮'
        }
        return typeMap[type]
      }
    },
    created() {
      this.getList()
      this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
      for(var i=0;i<this.permissions.length;i++){
        if(this.permissions[i] == 'sys_menu_add'){
          this.menuManager_btn_add = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_menu_edit'){
          this.menuManager_btn_edit = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_menu_del'){
          this.menuManager_btn_del = this.permissions[i]
        }

      }

    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
      getList() {
        fetchTree(this.listQuery.name).then(response => {
          console.log(typeof response.data)
          this.treeData = response.data
        })
      },
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },

      nodeExpand(data) {
        const aChildren = data.children
        if (aChildren.length > 0) {
          this.oExpandedKey[data.id] = true
          this.oTreeNodeChildren[data.id] = aChildren
        }
        this.setExpandedKeys()
      },
      nodeCollapse(data) {
        this.oExpandedKey[data.id] = false
        // 如果有子节点
        this.treeRecursion(this.oTreeNodeChildren[data.id], (oNode) => {
          this.oExpandedKey[oNode.id] = false
        })
        this.setExpandedKeys()
      },
      setExpandedKeys() {
        const oTemp = this.oExpandedKey
        this.aExpandedKeys = []
        for (const sKey in oTemp) {
          if (oTemp[sKey]) {
            this.aExpandedKeys.push(parseInt(sKey))
          }
        }
      },
      treeRecursion(aChildren, fnCallback) {
        if (aChildren) {
          for (let i = 0; i < aChildren.length; ++i) {
            const oNode = aChildren[i]
            fnCallback && fnCallback(oNode)
            this.treeRecursion(oNode.children, fnCallback)
          }
        }
      },

      getNodeData(data) {
        if (!this.formEdit) {
          this.formStatus = 'update'
        }
        getObj(objKeySort({id:data.id})).then(response => {
          console.dir(response)
          this.form = response.data
        })
        this.currentId = data.id
        this.currentName = data.name
        this.showElement = true
      },
      handlerEdit() {
        if (this.form.menuId) {
          this.formEdit = false
          this.formStatus = 'update'
        }
      },
      handlerAdd() {
        this.resetForm()
        this.formEdit = false
        this.formStatus = 'create'
      },
      handlerRootAdd(){
        this.resetForm()
        this.formEdit = false
        this.formStatus = 'create'
        this.form.parentId = -1
        this.form.parentName = '根节点'
      },
      handleDelete() {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delObj(objKeySort({id:this.currentId})).then(() => {
            this.getList()
            this.resetForm()
            this.onCancel()
            this.$message({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
          })
        })
      },
      update() {

        if(this.form.parentName||this.form.parentName == null){
          delete this.form.parentName
        }
        delete this.form.createTime
        delete this.form.updateTime
        console.log(this.form)
        putObj(objKeySort(this.form)).then(() => {
          this.getList()
          this.onCancel()
          this.$message({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000
          })
        })
      },
      create() {
        var addDate ={
          component:this.form.component?this.form.component:'',
          icon:this.form.icon?this.form.icon:'',
          method:this.form.method,
          name:this.form.name?this.form.name:'',
          parentId:this.form.parentId,
          parentName:this.form.parentName,
          path:this.form.path?this.form.path:'',
          permission:this.form.permission,
          sort:this.form.sort,
          type:this.form.type,
          url:this.form.url,

        }
        console.log(addDate)
        addObj(objKeySort(addDate)).then(() => {
          this.getList()
          this.onCancel()
          this.$message({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000
          })
        })
      },
      onCancel() {
        this.formEdit = true
        this.formStatus = ''
      },
      resetForm() {
        this.form = {
          permission: undefined,
          name: undefined,
          menuId: undefined,
          parentId: this.currentId,
          parentName: this.currentName,
          url: undefined,
          icon: undefined,
          sort: undefined,
          component: undefined,
          type: undefined,
          method: undefined,
          path: undefined
        }
      }
    }
  }
</script>
